import React, { Component } from "react";
import { ModalComponent } from "../reusableComponent/modal";
import { ModalTemplate } from "../reusableComponent/modalTemplate";
import DragDrop from "./dragDrop";
import { orderBy } from "lodash";
import TooltipComponent from "../../component/TooltipComponent";

export class SelectProjectOrdering extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isUsePresetCheckedForState: false,
      isUsePresetCheckedForCentral: false,
      isChecked: false,
      stateList: [],
      centralList: [],
      initialCentralList: props.centralProjectIdList || [],
      initialStateList: props.stateProjectIdList || [],
      isPresetChecked: false
    };
  }

  setStateList = list => {
    this.setState({
      stateList: list || []
    });
  };

  setCentralList = list => {
    this.setState({
      centralList: list || []
    });
  };

  getSectorWiseProjectCount = (
    selectedIssues,
    projectSector,
    pragatiReview
  ) => {
    let IssueWithCommonProjectSector =
      selectedIssues &&
      selectedIssues.length &&
      selectedIssues.filter(issue => {
        return (
          issue.projectSector === projectSector &&
          issue.pragatiReview === pragatiReview
        );
      });
    return IssueWithCommonProjectSector && IssueWithCommonProjectSector.length;
  };

  toggleUsePresetChangeForCentral = () => {
    const {
      centralProjectIdList = [],
      setFinalOrderingForCentral
    } = this.props;

    centralProjectIdList.map(item => {
      item.sectorWiseProjectCount = this.getSectorWiseProjectCount(
        centralProjectIdList,
        item.projectSector,
        item.pragatiReview
      );
      return item;
    });

    this.setState(
      {
        isUsePresetCheckedForCentral: !this.state.isUsePresetCheckedForCentral,
        isPresetChecked: !this.state.isPresetChecked
      },
      () => {
        if (this.state.isUsePresetCheckedForCentral) {
          let _centralProjectIdList = orderBy(
            centralProjectIdList,
            [
              "pragatiReview",
              "sectorWiseProjectCount",
              "projectSector",
              "totalCost"
            ],
            ["desc", "asc", "asc", "desc"]
          );
          //this.setCentralList(_centralProjectIdList);
          this.setState({
            centralList: _centralProjectIdList,
            key: Math.random()
          });
          setFinalOrderingForCentral(_centralProjectIdList);
        } else {
          this.setState({
            centralList: this.state.initialCentralList,
            key: Math.random()
          });
        }
      }
    );
    this.props.updatePresetForCentral(!this.state.isPresetChecked);
  };

  toggleUsePresetChangeForState = () => {
    const { stateProjectIdList = [], setFinalOrderingForState } = this.props;

    stateProjectIdList.map(item => {
      item.sectorWiseProjectCount = this.getSectorWiseProjectCount(
        stateProjectIdList,
        item.projectSector,
        item.pragatiReview
      );
      return item;
    });

    this.setState(
      {
        isUsePresetCheckedForState: !this.state.isUsePresetCheckedForState,
        isPresetChecked: !this.state.isPresetChecked
      },
      () => {
        if (this.state.isUsePresetCheckedForState) {
          let _stateList = orderBy(
            stateProjectIdList,
            [
              "pragatiReview",
              "sectorWiseProjectCount",
              "projectSector",
              "totalCost"
            ],
            ["desc", "asc", "asc", "desc"]
          );
          //this.setStateList(_stateList);
          this.setState({
            stateList: _stateList,
            key: Math.random()
          });
          setFinalOrderingForState(_stateList);
        } else {
          this.setState({
            centralList: this.state.initialStateList,
            key: Math.random()
          });
        }
      }
    );
  };

  toggleChange = () => {
    // false means centre selected
    this.setState({
      isChecked: !this.state.isChecked
    });
  };

  disablePresetCheckbox = () => {
    this.setState({
      isPresetChecked: false,
      isUsePresetCheckedForCentral: false,
      isUsePresetCheckedForState: false
    });
    this.props.updatePresetForCentral(this.state.isPresetChecked);
  };

  render() {
    const {
      show = false,
      onClose = () => {},
      title = "Set Order",
      onSubmitTitle = "APPLY",
      isLoading = false,
      centralProjectIdList = [],
      stateProjectIdList = [],
      setFinalOrderingForState,
      setFinalOrderingForCentral,
      onSubmit
    } = this.props;
    const {
      isUsePresetCheckedForState,
      isChecked,
      centralList,
      stateList,
      isUsePresetCheckedForCentral,
      isPresetChecked
    } = this.state;

    console.log("centralProjectIdList", centralProjectIdList);
    return (
      <div>
        {show ? (
          <ModalComponent
            centered={true}
            onClose={() => {
              this.setState(
                {
                  error: {},
                  stateList: [],
                  centralList: [],
                  isChecked: false,
                  isUsePresetCheckedForCentral: false,
                  isUsePresetCheckedForState: false,
                  isPresetChecked: false
                },
                () => {
                  onClose();
                }
              );
            }}
            containerClass="set-order-modal"
            isLoading={isLoading}
            template={
              <ModalTemplate
                bodyTemplate={
                  <>
                    <h4>{title}</h4>
                    <p>
                      Drag and drop the tiles to set display order of the issues
                    </p>
                    <div className="set-order-function-box">
                      <div className="set-item-toggle">
                        <span className="toggle-central">Central</span>
                        <label className="switch">
                          <input
                            type="checkbox"
                            checked={isChecked}
                            onChange={this.toggleChange}
                          />
                          <span className="slider round" />
                        </label>
                        <span className="toggle-state">State</span>
                      </div>
                      <div className="set-item-checkbox">
                        <div className="checkbox">
                          <label>
                            {isChecked ? (
                              <input
                                type="checkbox"
                                checked={isPresetChecked}
                                onChange={this.toggleUsePresetChangeForState}
                              />
                            ) : (
                              <input
                                type="checkbox"
                                checked={isPresetChecked}
                                onChange={this.toggleUsePresetChangeForCentral}
                              />
                            )}
                            Use Preset
                          </label>
                        </div>
                        <div>
                          <TooltipComponent
                            classes="info-blue"
                            content={
                              "Sorting grouped by sector and arranged by cost"
                            }
                          />
                          {/*<img src={info_blue} alt="info" className="info-blue"/>*/}
                        </div>
                      </div>
                    </div>
                    {isChecked ? (
                      stateProjectIdList && stateProjectIdList.length ? (
                        <div>
                          <DragDrop
                            setFinalOrdering={setFinalOrderingForState}
                            projectIdList={stateProjectIdList}
                            setList={this.setStateList}
                            midList={stateList}
                            category={"STATE"}
                            key={this.state.key}
                          />{" "}
                        </div>
                      ) : null
                    ) : centralProjectIdList && centralProjectIdList.length ? (
                      <DragDrop
                        setFinalOrdering={setFinalOrderingForCentral}
                        projectIdList={centralProjectIdList}
                        setList={this.setCentralList}
                        midList={centralList}
                        category={"CENTRAL"}
                        key={this.state.key}
                        onDragStart={this.disablePresetCheckbox.bind(this)}
                      />
                    ) : null}
                  </>
                }
                onSubmit={() => {
                  onSubmit();
                  onClose();
                }}
                footerDisplay={true}
                onClose={() => {
                  this.setState(
                    {
                      error: {},
                      stateList: [],
                      centralList: [],
                      isChecked: false,
                      isUsePresetChecked: false
                    },
                    () => {
                      onClose();
                    }
                  );
                }}
                onSubmitTitle={onSubmitTitle}
              />
            }
          />
        ) : null}
      </div>
    );
  }
}
